export default "__VITE_ASSET__BDR5KqvR__"